export default __webpack_public_path__ + "static/media/tool-icon-cone-orange.f19aa423.svg";